import React, {useContext} from 'react';
import AppContext from '../../../utility/AppContext';
import Box from '@material-ui/core/Box';
import {Button} from '@material-ui/core';
import styled from 'styled-components';

const FooterStyled = styled(Box)`
  ${(props) => `    
      position: fixed;
      left: auto;
      bottom: 0;
      z-index: 99;
      margin: 0;
      width: 100%;
      background-color: ${props.theme.palette.background.paper};
      color: ${props.theme.palette.text.primary};
      
      ${props.theme.breakpoints.up('lg')} {
        width: calc(100vw - 19rem);
      }
      
      ${props.theme.breakpoints.up('xl')} {
        width: calc(100vw - 21.6rem);
      }
      
      & .footer-container {
        padding: 5px 20px;
        
        ${props.theme.breakpoints.up('md')} {
          padding-left: 32px;
          padding-right: 32px;
        }
        
        ${props.theme.breakpoints.up('xl')} {
          padding: 10px 32px;
        }
      }
      
      & .btn {
        padding-left: 20px;
        padding-right: 20px;
      }
  `}
`;

const AppFixedFooter = (props) => {
  const {footer, footerType} = useContext(AppContext);

  return (
    <>
      {footer && footerType === 'fixed' ? (
        <FooterStyled className='footer'>
          <Box
            className='footer-container'
            alignItems='center'
            flexDirection='row'
            display='flex'>
            <Box>Copy right @crema 2020</Box>
            <Box ml='auto'>
              <Button className='btn' color='primary'>
                Buy Now
              </Button>
            </Box>
          </Box>
        </FooterStyled>
      ) : null}
    </>
  );
};

export default AppFixedFooter;
